import React from 'react';
import { cn } from '../lib/utils';
import { MessageSquare } from 'lucide-react';
import { useChat } from '../contexts/ChatContext';
import { useIsMobile } from '../hooks/use-mobile';

const MiniButton = ({ isMiniMode, toggleMiniMode, isMinimized, toggleMinimized }) => {
  const { messages } = useChat();
  const isMobile = useIsMobile();
  const unreadMessages = messages?.length > 1;
  return (
    <button
      onClick={toggleMiniMode}
      className={cn(
        "fixed z-50 text-white rounded-full shadow-lg transition-all duration-300 flex items-center justify-center bottom-4 right-4",
        isMobile
          ? "w-12 h-12 bg-gradient-to-br from-indigo-600 to-indigo-500"
          : "w-14 h-14 bg-gradient-to-br from-indigo-600 to-indigo-500"
      )}
      aria-label="Open chat assistant"
    >
      <MessageSquare className={cn(
        "transition-all",
        isMobile ? "h-5 w-5" : "h-6 w-6"
      )} />
      {isMinimized && unreadMessages && (
        <span className={cn(
          "absolute bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center animate-pulse",
          isMobile 
            ? "-top-1 -right-1 w-5 h-5"
            : "-top-1 -right-1 w-5 h-5"
        )}>
          {messages.length - 1 > 9 ? '9+' : messages.length - 1}
        </span>
      )}
      <span className="absolute inset-0 rounded-full bg-white/20 transform scale-100 opacity-0 animate-ping-slow"></span>
    </button>
  );
};

export default MiniButton; 